// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"98":"009e9d109d3063250ef8","888":"ece13e183c149c35a068"}[chunkId] + ".css";
};